import React from 'react'
import mainBG from '../../../assets/EinführungMainBG.png'
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { setLanguage } from "../../../redux/language/languageSlice";
import GrFlag from '../../../assets/icons/germany_flag.svg'
import TrFlag from '../../../assets/icons/turkey_flag.svg'
import HrFlag from '../../../assets/icons/croatia_flag.svg'

const OnlineGuide = ({ nextClick }) => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const currentLanguage = useSelector((state) => state.language);
    const handleLanguageChange = (lng) => {
        i18n.changeLanguage(lng);
        dispatch(setLanguage(lng)); // Persist in Redux
    };

    return (
        <>
            <div style={{ background: `url(${mainBG})` }} className='h-screen !bg-cover !bg-no-repeat !bg-center flex flex-col justify-between relative'>
                <div className="absolute sm:min-w-60 top-2 right-1 transform-none  ">
                    <div className="flex gap-1 md:bg-[#F9DCD4] justify-center items-center p-2 rounded-md">
                        <button className={`flex items-center font-bold gap-2 w-4 md:w-12 mx-2 text-[18px] md:text-[20px] ${currentLanguage?.language == 'de' ? 'text-mainBlue' : ''} `} onClick={() => handleLanguageChange('de')}  >
                            {/* <img src={GrFlag} className='w-6' alt="" /> */}
                            DE</button>
                        <button className={`flex items-center font-bold gap-2 w-6 md:w-12 mx-2 text-[18px] md:text-[20px] ${currentLanguage?.language == 'hr' ? 'text-mainBlue' : ''} `} onClick={() => handleLanguageChange('hr')} >
                            {/* <img src={HrFlag} className='w-6' alt="" /> */}
                            BKS</button>
                        <button className={`flex items-center font-bold gap-2 w-4 md:w-12 mx-2 text-[18px] md:text-[20px] ${currentLanguage?.language == 'tr' ? 'text-mainBlue' : ''} `} onClick={() => handleLanguageChange('tr')}  >
                            {/* <img src={TrFlag} className='w-6' alt="" /> */}
                            TR</button>
                    </div>
                    {/* <select
                        id="language"
                        value={currentLanguage.language}
                        onChange={(e) => handleLanguageChange(e.target.value)}
                        className="block w-full p-2 border border-gray-300 rounded-lg bg-white text-black shadow-sm focus:ring focus:ring-white focus:border-white"
                    >
                        <option value="" disabled>
                            Choose a language
                        </option>
                        <option value="de">German</option>
                        <option value="hr">Croatian</option>
                        <option value="tr">Turkish</option>
                    </select> */}

                </div>
                <div className="">
                    <div className="lg:mt-8 mt-24 text-center text-mainBlue text-6xl font-medium hidden sm:block">
                        My Simurg Guide.
                    </div>
                    <div className="mt-8 text-mainBlue text-6xl flex flex-col gap-10 font-bold mx-4 sm:hidden">
                        <span>My</span>
                        <span>Simurg</span>
                        <span>Guide</span>
                    </div>
                    <div className="mt-2 hidden sm:block text-center text-mainBlue text-2xl font-medium">
                        {t(`s-0-title`)}
                    </div>

                </div>
                <div className="bordered-text sm:mt-auto mt-0 md:text-center text-left mx-4">
                    Discover the power in you!
                </div>
                <div className='py-8 mx-4 sm:mx-auto space-y-3'>
                    {/* <div className="block md:hidden">
                        <div className="flex gap-1 button_secodry justify-center items-center p-2 rounded-md">
                            <button className={`flex items-center font-bold gap-2 w-12 mx-2 text-[20px] ${currentLanguage?.language == 'de' ? 'text-mainBlue' : ''} `} onClick={() => handleLanguageChange('de')}  >
                               
                                DE</button>
                            <button className={`flex items-center font-bold gap-2 w-12 mx-2 text-[20px] ${currentLanguage?.language == 'hr' ? 'text-mainBlue' : ''} `} onClick={() => handleLanguageChange('hr')} >
                                BKS</button>
                            <button className={`flex items-center font-bold gap-2 w-12 mx-2 text-[20px] ${currentLanguage?.language == 'tr' ? 'text-mainBlue' : ''} `} onClick={() => handleLanguageChange('tr')}  >
                                TR</button>
                        </div>
                        <select
                            value={currentLanguage?.language}
                            className="w-full flex items-center sm:hidden min-w-[300px] bg-[#2A2A2A] text-white border border-zinc-800 px-4 py-2 rounded-md button_secondry_bg appearance-none"
                            onChange={(e) => handleLanguageChange(e.target.value)}
                        >
                            <option value="de">DE</option>
                            <option value="hr">EN</option>
                            <option value="tr">FR</option>
                        </select>
                    </div> */}

                    <button className='w-full button_secodry min-w-[300px] button_secondry_bg' onClick={() => nextClick()}> {t(`s-1-btn`)} </button>
                </div>
            </div>
        </>
    )
}

export default OnlineGuide